import { MODEL_NAMES } from '../../constants/index';
import { TrackedObject } from 'tracked-built-ins';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesConversationListHandler extends MessagingRoutesBaseHandler {
  @service infinity;
  @service messaging;
  @service store;

  constructor(owner, options = {}) {
    super(owner, new TrackedObject(options));
  }

  get conversations() {
    return this.messaging.conversations;
  }

  get currentProfile() {
    return this.messaging.currentProfile;
  }

  get isLoadingConversations() {
    return this.messaging.isLoadingConversations;
  }

  get groupMessagingEnabled() {
    return this.messaging.groupMessagingEnabled;
  }

  get hasSearchTerm() {
    return this.messaging.hasSearchTerm;
  }

  get sortedConversations() {
    if (this.conversations.length === 0) return [];

    const unreadIds = new Set(this.currentProfile?.unreadConversationIds || []);
    const draftIds = new Set(this.conversations.content.filter(c => c.hasMessageDraft).map(c => c));

    return this.conversations.content.toSorted((a, b) => {
      return (
        draftIds.has(b) - draftIds.has(a) ||
        unreadIds.has(b.id) - unreadIds.has(a.id) ||
        new Date(b.updatedAt) - new Date(a.updatedAt)
      );
    });
  }

  loadMoreConversations = task({ drop: true }, async model => {
    if (!model.canLoadMore) return;
    await this.infinity.loadNextPage(model);
  });

  toggleAwayStatus = task({ drop: true }, async isAway => {
    await this.store
      .adapterFor(MODEL_NAMES.PROFILE)
      .updateAwayStatus(this.currentProfile.id, isAway);

    this.currentProfile.isAway = isAway;
  });
}
